"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LeftPanel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LeftPanel = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    position: fixed;\n    top: 40px;\n    left: -505px;\n    bottom: 0;\n    width: 500px;\n    overflow: auto;\n    z-index: 100;\n    box-shadow: 0px 0px 5px 0px #cecdcd;\n    transition: left 0.15s linear;\n    padding: 10px;\n\n    &.active {\n        left: 0;\n    }\n"])), function (props) {
  return props.theme.admin.colors.background;
});

exports.LeftPanel = LeftPanel;